<template>
  <div class="outpatient-box">
    <van-cell title="选择挂号日期" :value="selectTime" is-link @click="timeShow = !timeShow">
      <van-icon v-if="!timeShow" slot="right-icon" class="date-icon" name="arrow" color="#999" />
      <van-icon v-if="timeShow" slot="right-icon" class="date-icon" name="arrow-down" color="#999" />
    </van-cell>

    <week v-if="timeShow" v-model="selectTime" :week-status="weekStatus" />

    <van-tabs v-if="keepList.length || doctorList.length" v-model="activeName" class="tabs-box">
      <van-tab v-if="keepList.length && !dataLoading" title="普通号" name="ordinary">
        <doctor-info :list="keepList" @doctorClick="doctorInfoFun" />
      </van-tab>
      <van-tab v-if="doctorList.length && !dataLoading" title="专家号" name="experts">
        <doctor-info :list="doctorList" @doctorClick="doctorInfoFun" />
      </van-tab>
    </van-tabs>
    <NoData v-if="!keepList.length && !doctorList.length && !dataLoading" />
    <van-loading v-if="dataLoading" size="50" />
  </div>
</template>

<script>
// import TimeCell from './components/timeCell'
import Week from '../../components/week'
import DoctorInfo from '../../components/doctorInfo'
import moment from 'moment'
export default {
  name: 'Registered',
  components: {
    DoctorInfo,
    Week
    // TimeCell
  },
  data() {
    return {
      id: '',
      activeName: 'ordinary',
      selectTime: '',
      registeredType: 'time',
      timeShow: true,
      dataLoading: false,
      doctorList: [],
      keepList: [],
      weekStatus: {}
    }
  },
  watch: {
    selectTime(val) {
      this.getKeep()
    }
  },
  created() {
    this.selectTime = this.$utils.dateFormat('YYYY-mm-dd', new Date())
    this.id = this.$route.query.id || ''
    this.getKeepsNum()
  },
  mounted() {},
  methods: {
    // 日期是否展开
    timeShowFun() {
      this.timeShow = !this.timeShow
    },
    // 选择日期 格式化 赋值
    calendarSelectFun(value) {
      this.selectTime = this.$utils.dateFormat('YYYY-mm-dd', value)
      this.timeShow = false
      this.getKeep()
    },
    // 挂号方式 切换
    registeredTypeFun(type) {
      this.registeredType = type
    },
    // 挂号 预约 医生
    doctorInfoFun(item, noon) {
      if (item.keepNumbers) {
        this.$router.push(`/registeredDetails?doctorCode=${item.doctorCode}&deptCode=${this.id}&time=${this.selectTime}&noon=${noon}`)
        localStorage.setItem('titleCode', item.titleCode || '')
      } else {
        this.$toast({
          message: '余号不足',
          position: 'top',
          duration: 500
        })
      }
    },
    toQueren(item) {
      localStorage.setItem('yuyueInfo', JSON.stringify(item))
      this.$router.push(`/guahaoqueren?id=${item.id}`)
    },
    // 获取普通号 排版信息
    getKeep() {
      const parms = {
        day: this.selectTime,
        deptCode: this.id
      }
      this.dataLoading = true
      this.$Apis.getKeeps(parms).then(res => {
        this.dataLoading = false
        if (res.code === 200) {
          this.keepList = res.data?.common
          this.doctorList = res.data?.export
        } else {
          this.keepList = []
          this.doctorList = []
        }
      }).catch(() => {
        this.keepList = []
        this.doctorList = []
        this.dataLoading = false
      })
    },
    // 获取所有日期排版
    getKeepsNum() {
      const parms = {
        day: this.selectTime,
        deptCode: this.id,
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().add(14, 'day').format('YYYY-MM-DD')
      }
      this.$Apis.getKeepsNum(parms).then(res => {
        console.log(res)
        if (res.code === 200) {
          const weekStatus = {}
          res.data.forEach(item => {
            weekStatus[item.date] = item.number > 0
          })
          this.weekStatus = weekStatus
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  /deep/.van-loading{
    margin-top: 1rem;
    text-align: center;
  }
  .tab-select-box {
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    align-items: center;
    padding: 10px;
  }

  .registered-type {
    display: flex;
    border: 1px solid #00a6ff;
    color: #00a6ff;
    border-radius: 4px;

    > div {
      padding: 8px;
    }

    .active {
      background-color: #00a6ff;
      color: #fff;
    }
  }

  .van-cell {
    align-items: center;
  }

  .doctor-num {
    font-size: 12px;
    color: #ffffff;
    > span {
      background-color: #d2d2d2;
      margin-right: 5px;
      border-radius: 4px;
      padding: 2px 5px;
    }
  }

  .date-icon {
    line-height: inherit;
    margin-left: 10px;
  }
</style>
